Handler = require('resources/assets/coffee/Core/Handler').Handler

class exports.Storage
    constructor: () ->
        @data = {}
        @key_count = 0


    # Return all data items
    all: () ->
        return @data

    # Empties out the storage object
    empty: () ->
        @delete(k) for k, v of @data

    # Returns an array of all of the keys in the storage object
    keys: () ->
        k for k of @data


    # Returns only items whose keys are specified as arguments
    #
    #   Example: store.only("test", "test2")
    only: (keep...) ->
        result = {}
        for key in keep
            if @data[key]?
                result[key] = @data[key]

        return result

    # Returns all items except those whose keys are specified as arguments
    #
    #   Example: store.except("test3", "test4")
    except: (reject...) ->
        result = {}
        for key, value of @data
            if key not in reject
                result[key] = value

        return result


    # Delete an item from the store
    delete: (k) ->
        v = @retrieve(k)
        if v?
            if v instanceof Handler
                v.destroy()

            delete @data[k]

            @key_count = @key_count - 1


    # Fetch an item from the store
    retrieve: (k, def = null) ->
        return @data[k] ? def


    # Place an item in the store
    store: (k, v) ->
        @data[k]        = v
        @key_count      = @key_count + 1


    # Does the specified key exist in the store?
    exists: (k) ->
        if @data[k]?
            return true
        else
            return false


    # Map a callback over each element in the store
    each: (callback = -> undefined) ->
        for k, v of @data
            callback(k, v)


    # Returns the number of stored keys
    count: () ->
        return @key_count
